<div class="sam-form-row sam-margin" *ngFor="let item of agentGreetings">
   <samweb-drag-container
      class="sam-display-contents sam-draggable"
      *ngIf="!(item | isNil | async)"
      [zoneId]="item.id"
      [availableDropZones]="availableDropZones"
      [item]="item"
      [disabled]="disabled"
      (dragStart)="dragStart($event)"
      (dragEnd)="dragEnd($event)"
   >
      <samweb-dialog-tooltip
         class="sam-display-contents"
         itemContent
         [isDialogOpen]="(editedWave$ | async) === item?.id && (isDialogOpen$ | async)"
         (dialogClosed)="dialogClosed(item)"
      >
         <samweb-agent-greeting-wave
            class="sam-full-width"
            *ngIf="!(item | isNil | async)"
            [wave]="item"
            [tooltipTranslation]="'common.remove'"
            (removeWave)="displayDialog(item)"
            [displayClear]="!((editedWave$ | async) === item?.id && (isDialogOpen$ | async))"
         >
         </samweb-agent-greeting-wave>
         <div dialog class="sam-margin sam-form-row">
            <div class="sam-margin sam-bold">
               {{ 'common.settings.agent_greetings.remove_file_dialog.title' | translate }}
            </div>
            <div class="sam-margin">
               <div class="sam-margin"></div>
               <div>{{ 'common.settings.agent_greetings.remove_file_dialog.message' | translate }}</div>
               <div class="sam-margin sam-auto-overflow" style="max-height: 10em">
                  <div class="sam-form-row sam-margin" *ngFor="let assignedEntry of currentEntries$ | async">
                     <div class="sam-form-flex-row sam-margin-left-large">
                        <samweb-skill-short-info
                           fxFlex="0 0 auto"
                           fxFlexAlign="center"
                           [skillConfiguration]="assignedEntry?.skill?.skillConfiguration"
                           [skills]="assignedEntry?.skill?.skills"
                        ></samweb-skill-short-info>
                        <div class="sam-margin-left">-</div>
                        <div class="sam-margin-left">{{ assignedEntry?.iciName | translate }}</div>
                     </div>
                  </div>
               </div>
               <div class="sam-margin"></div>
               <div class="sam-full-width sam-end">
                  <button kendoButton (click)="removeWave(item)">
                     {{ 'common.settings.agent_greetings.remove_file_dialog.remove_button' | translate }}
                  </button>
               </div>
            </div>
         </div>
      </samweb-dialog-tooltip>
      <samweb-agent-greeting-wave
         dragPreview
         class="sam-full-width"
         *ngIf="!(item | isNil | async)"
         [wave]="item"
         [displayClear]="false"
      >
      </samweb-agent-greeting-wave>
      <samweb-agent-greeting-wave
         dragPlaceHolder
         class="sam-full-width"
         *ngIf="!(item | isNil | async)"
         [wave]="item"
         [displayClear]="false"
      >
      </samweb-agent-greeting-wave>
   </samweb-drag-container>
</div>
